// Adds the URLS object to the Axios requests module
// eg: Dashboard: '/dashboard'

const URLS = {
  TRANSMISSION_TYPE: "/motor-transmission-types",
  SHORTLISTED: "shortlisted-quotes",
  COMPARED: "compared-quotes",
  GEO_SCOPES: "geo-scopes",
  SPECIALIZATIONS: "specializations",
  BUSINESS_TYPES: "business-types",
  COMMISSION_SETTING: "/commission-settings",
  CATTLE_BREEDS: "/cattle-breeds",
  WORK_TYPES: "/worker-types",
  CATTLE_TYPES: "/cattle-types",
  TRAVEL_MODES: "/travel-modes",
  CURRENCIES: "/currencies",
  COUPONS: "/coupons",
  CARD_TYPES: "/card-types",
  CARDS: "/cards",
  ENTITIES: "/entities",
  SPECIES: "/species",
  PARTNERS: "/partners",
  PARTNER_ROLE: "/partner/roles",
  PARTNER_CUSTOMER_UPLOAD: "/partner/customers/upload",
  PRODUCTS: "/products",
  USERS: "/users",
  STATES: "/states",
  RELATIONS: "/relations",
  GENDER: "/genders",
  CREDENTIALS: "/credentials",
  LOGIN: "/user/login",
  LOGOUT: "/user/logout",
  AUTH_USER: "/user",
  INSURERS: "/insurers",
  CITIES: "/cities",
  PRODUCT_TYPES: "/product-types",
  ALERT: "/alerts",
  PINCODES: "/pincodes",
  PAYMENT_MODE: "/payment-modes",
  RATERS: "/raters",
  BANK_BRANCHES: "/bank-branches",
  THEMES: "/themes",
  THEMES_SETTINGS: "/theme-settings",
  PARTNER_BRANCHES: "/partner-branches",
  DECLARATIONS: "/declarations",
  POLICIES: "/policies",
  ENQUIRIES: "/enquiries",
  CERTIFICATE_TEMPLATES: "/certificate-templates",
  ALERT_TEMPLATES: "/alert-templates",
  ROLES: "/roles",
  PLANS: "/plans",
  COMBOS: "/combos",
  CASH_DEPOSITS: "/cash-deposits",
  ACCOUNTS: "/accounts",
  TRANSACTIONS: "/transactions",
  DEFAULT_ALERT_TEMPLATES: "/default-alert-templates",
  GENERAL_SETTINGS: "/general-settings",
  PROPERTY_COVERAGES: "/property-coverages",
  CANCELLATION_REASONS: "/cancellation-reasons",
  PROFILE: "/profile",
  FEATURES: "/features",
  FEATURE_CATEGORIES: "/feature-categories",
  JOURNEYS: "/journeys",
  PARTNER_THEMES: "/partner/themes",
  PARTNER_USERS: "/partner/users",
  PARTNER_CUSTOMER: "/partner/customers",
  PARTNER_THEMES_SETTINGS: "/partner/theme/select",
  SEGMENTS: "/segments",
  SUBSEGMENTS: "/sub-segments",
  API_TOKENS: "/tokens",
  CERTIFICATES: "/certificates",
  CERTIFICATES_STAGES: "/certificate-stages",
  ENQUIRY_STAGES: "/enquiry-stages",
  PARTNER_REGIONS: "/partner/regions",
  ZONES: "/zones",
  BREEDS: "/breeds",
  COUNTRIES: "countries",
  ACTIVITIES: "/activities",
  PAYMENT_GATEWAYS: "/payment-gateways",
  OCCUPATIONS: "/occupations",
  REPORTS: "/reports",
  DATA_SOURCES: "/data-sources",
  NATURE_OF_BUSINESS: "/business-natures",
  INCO_TERMS: "/incoterms",
  PACKAGING_TYPES: "packaging-types",
  EVENT_TYPES: "event-types",
  COMMISSIONS: "/commissions",
  DASHBOARD: "dashboards",
  RIDERS: "/riders",
  COMMODITY: "/commodity-types",
  OCCUPANCY_TYPE: "/occupancy-types",
  BLOCKED_AREAS: "/blocked-locations",
  GADGETS: "/gadgets",
  KNOCKOUT_QUESTIONS: "knockout-questions",
  QUESTIONS: "questions",
  PARTNER_LANDING_PAGE: "/partner/landing-pages",
  BROKER_LANDING_PAGE: "/landing-pages",
  CLAIM_SETTLEMENT_TYPE: "/claim-settlement-types",
  ENQUIRY: "/enquiry",
  ENQUIRY_SUBJECT: "/enquiry/subjects",
  CLAIMS: "/claims",
  CLAIMS_EXPENSES: "/claim-expenses",
  CLAIM_TYPES: "/claim-types",
  CLAIM_STAGES: "/claim-stages",
  CLAIM_DASHBOARD: "/claim-dashboards",
  ENDORSEMENT_PREVIEW: "/endorsements/preview",
  ENDORSEMENTS: "/endorsements",
  COVERS: "/covers",
  ALERT_LOGS: "/alert-logs",
  CERTIFICATE_CANCELLATION_REASON: "/cancellation-reasons",
  UPLOAD_CERTIFICATE: "/upload-certificate-data-logs",
  BRANCHES: "/branches",
  CLAIM_TEMPLATES: "/claim-templates",
  CLAIM_TEMPLATE: "/claim-template",
  CLAIM_TYPE_FIELDS: "/claim-type-fields",
  PRODUCT_CLAIM_TEMPLATE: "/product-claim-templates",
  CLAIM_TEMPLATE_FIELDS: "claim-template-fields",
  MISSING_FIELDS: "missing-fields",
  CONFIGURED_CLAIMS: "/configured-claims",
  CRITICALILLNESSES: "/critical-illness-types",
  DUMMYRESPONSE: "/dummy-response",
  GENERATE_PARTNER_TOKEN: "/generate-partner-token",
  VERIFY_DASHBOARD_TOKEN: "/dashboard-verify-token",
  LOADER_FILE: "/loader-file",
  PREFILLED_DATA: "/prefilled-data",
  CAPTCHA: "/captcha",
  FRONTEND_BOOT: "/frontend-boot",
  MANUFACTURER: "/motor-brands",
  FUEL_TYPES: "/motor-fuel-types",
  VARIANT: "/motor-variants",
  MODEL: "/motor-models",
  CONSENT: "/consents",
};
export default URLS;
